// Author YuJiaBei
// Date 2022-04-07 21:06:18

import * as model from "@/model/em/opcClient/EmOpcComputedActionEocaModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmOpcComputedActionEoca(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_OPCCLIENT_URL,
    })
    .buildStore()
